import * as types from '@/store/mutation-types'
import * as api from '@/api'

const _ = require('lodash')

// initial state
const state = {
  trigger: {
    openFilterPopover: false
  },
  defaultSeason: 'winter',
  gender: {
    selected: '29|94',
    selectedLabel: 'women',
    list: [
      {value: '29|94', label: 'women', key: 'women', seasonLess: false},
      {value: '28|93', label: 'men', key: 'men', seasonLess: false},
      {value: '104|69', label: 'kids', key: 'kids', seasonLess: false},
      {value: '153', label: 'accessories', key: 'accessories', seasonLess: true}
    ],
    type: 'button',
    key: 'g',
    class: 'hidden',
    reset_filters: true,
    update_route: true,
    filtersReady: false // when all filters are ready
  },
  season: {
    label: 'season',
    placeholder: 'season',
    selected: '',
    list: [
      {value: '93|94|104', label: 'winter', key: 'winter'},
      {value: '29|28|69', label: 'summer', key: 'summer'}
    ],
    type: 'button',
    key: 's',
    class: 'visible-xs visible-sm',
    reset_filters: true,
    update_route: true,
    togglable: false
  },
  type: {
    label: 'type',
    key: 't',
    selected: '0',
    placeholder: 'view_all',
    list: [],
    type: 'button',
    class: 'hidden',
    nextIsMore: true,
    default: '0',
    togglable: true
  },
  colors: {
    label: 'colors',
    key: 'c',
    selected: [],
    list: [],
    type: 'color',
    class: '',
    mobile: true,
    default: []
  },
  sizes: {
    label: 'sizes',
    key: 'sizes',
    selected: [],
    placeholder: 'sizes',
    list: [],
    listAdults: ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', '4xl'],
    listKids: ['3y', '4y', '6y', '8y', '10y', '12y', '14y', '16y'],
    type: 'selectV2',
    multiple: false,
    boolean: false,
    class: '',
    default: [],
    togglable: true
  },
  fit: {
    label: 'fit',
    key: 'ft',
    selected: [],
    placeholder: 'fit',
    list: [],
    type: 'selectV2',
    multiple: false,
    boolean: false,
    class: '',
    default: [],
    togglable: true,
    customFilterConfig: {
      filterKey: 'properties',
      values: ['205', '206']
    }
  },
  reversible: {
    label: 'reversible',
    key: 'rvrsbl',
    selected: [],
    placeholder: 'reversible',
    list: [],
    type: 'selectV2',
    multiple: false,
    boolean: true,
    class: '',
    default: [],
    togglable: true,
    customFilterConfig: {
      filterKey: 'properties',
      values: ['203', '406']
    }
  }
}

// mutations
const mutations = {
  [types.SEASON_LESS]: (state, seasonLess) => {
    if (seasonLess) {
      state.season.selected = ''
    } else if (state.season.selected === '') {
      state.season.selected = state.season.list.find(row => row.key === state.defaultSeason).value
    }
    document.querySelector('.js-nav-season').classList.toggle('hidden', seasonLess)
  },
  [types.SET_FILTER]: (state, {filter, key, value}) => {
    filter.selected = value
    if (typeof window.universalGaCall === 'function') {
      window.universalGaCall('product-list', 'click', key, Array.isArray(value) ? value.join('|') : value)
    }
  },
  [types.SET_BASE_FILTERS]: (state, filterList) => {
    Object.keys(filterList).forEach(filterKey => {
      state[filterKey].selected = filterList[filterKey]
    })
  },
  [types.RESET_FILTERS]: (state, filterList) => {
    _.forEach(filterList, (filter) => {
      state[filter].selected = state[filter].default
    })

    const filterTypeElems = [].slice.call(document.querySelectorAll('.js-filter-type'))

    filterTypeElems.forEach($filter => {
      $filter.classList.remove('is-active')
    })
  },
  [types.SET_LOCALE]: (state, {copyList, lang}) => {
    _.forEach(copyList, (copy, labelKey) => {
      _.forEach(state, filter => {
        let filterItem
        if (_.size(filter.list) > 0) {
          filterItem = _.find(filter.list, ['label', labelKey])
          if (filterItem !== undefined) {
            filterItem.label = copy[lang]
          }
        }
        if (filter.placeholder === labelKey) {
          filter.placeholder = copy[lang]
        }
      })
    })
  },
  [types.RECEIVE_FILTERS]: (state, filters) => {
    _.each(filters, (filter, filterName) => {
      if (state[filterName] === undefined) return
      state[filterName].list = filter

      if (filterName === 'type') {
        const filterTypeElems = [].slice.call(document.querySelectorAll('.js-filter-type'))
        filterTypeElems.forEach(filterTypeElem => filterTypeElem.classList.remove('has-value'))

        filter.forEach(type => {
          const filterBtn = document.querySelector('.js-filter-type-' + type.value)

          if (!filterBtn) return
          filterBtn.classList.add('has-value')
        })
      }
    })

    state.gender.filtersReady = true
  },
  [types.TOGGLE_FILTER_POPOVER]: (state, visibility) => {
    state.trigger.openFilterPopover = visibility
  },
  [types.SET_DYNAMIC_FILTERS]: (state, filterValues) => {
    const appFilterLinks = document.querySelectorAll('.js-app-filter-link')
    for (let i = 0; i < appFilterLinks.length; i++) {
      const btn = appFilterLinks[i]
      if (filterValues.indexOf(btn.getAttribute('data-filter-value')) !== -1) {
        btn.classList.add('is-active')
      }
    }
  },
  /**
   * Populate new filters (V3)
   * @param state
   * @param filtersFromAPI
   */
  [types.SET_CUSTOM_FILTERS]: (state, payload) => {
    const customFilters = ['fit', 'reversible']
    customFilters.forEach(customFilter => {
      const filterKey = state[customFilter].customFilterConfig.filterKey
      const filterValues = state[customFilter].customFilterConfig.values
      state[customFilter].list = payload.filters[filterKey].filter(entry => filterValues.includes(entry.value))
    })

    state.sizes.list = payload.currentGender === 'kids' ? state.sizes.listKids : state.sizes.listAdults
    state.sizes.list = state.sizes.list.map(size => ({label: size.toUpperCase(), value: size}))
  }
}

// getters
const getters = {
  defaultSeason: state => state.defaultSeason,
  openFilterPopover: state => state.trigger.openFilterPopover,
  filtersReady: state => state.gender.filtersReady,
  allFilters: (state, getters) => {
    if (getters.searchMode) {
      const searchDynamicFilter = getters.searchDynamicFilters
      return [
        searchDynamicFilter.season,
        searchDynamicFilter.gender
      ]
    } else if (state.season.selected === '') {
      return [
        state.colors,
        state.sizes
      ]
    } else {
      return [
        state.season,
        state.colors,
        state.sizes,
        state.fit,
        state.reversible
      ]
    }
  },
  selectedFilters: state => {
    const genderLabel = _.find(state.gender.list, ['value', state.gender.selected])
    const selectedSeason = state.season.list.find(row => row.value === state.season.selected)
    const seasonLabel = selectedSeason ? selectedSeason.label : ''
    return {
      g: state.gender.selected,
      gKey: genderLabel.key,
      s: state.season.selected === '' ? state.gender.selected : state.season.selected,
      sLabel: seasonLabel,
      t: state.type.selected,
      c: state.colors.selected.join('|'),
      ft: state.fit.selected.join('|'),
      rvrsbl: state.reversible.selected.join('|'),
      size: state.sizes.selected.join('|')
    }
  },
  selectedFiltersString: (state, getters) => {
    if (!state.gender.filtersReady) return []
    const filterList = ['colors', 'sizes', 'fit', 'reversible']

    return filterList
    .filter(filterKey => {
      const selected = state[filterKey].selected
      if (_.isArray(selected)) {
        return selected.length !== 0
      } else {
        return selected.toString() !== '' && selected.toString() !== '0'
      }
    })
    .map(filterKey => {
      return {
        'name': getters.copy(filterKey),
        'type': state[filterKey].type,
        'value': getters.filterLabel(filterKey, state[filterKey].selected),
        'label': state[filterKey].label
      }
    })
  },
  selectedColorList: state => {
    return state.colors.selected
    .map(color => {
      const c = _.find(state.colors.list, ['value', color])
      return c ? c.id : null
    })
    .filter(color => color !== null)
  },
  seasonURI: state => {
    const season = _.find(state.season.list, ['value', state.season.selected])
    return season.label.replace(/é/gi, 'e').replace(/ /g, '-').toLowerCase()
  },
  filterLabel: (state, getters) => (filterKey, selectedValue) => {
    if (state[filterKey].type === 'button') {
      return _.find(state[filterKey].list, ['value', selectedValue]).label
    } else {
      return getters.selectedColorList
    }
  },
  currentGender: (state) => {
    return state.gender.list.find(g => g.value === state.gender.selected).key
  },
  filters: (state) => {
    return state
  }
}

const actions = {
  setFilter: (store, payload) => {
    if (store.getters.searchMode) {
      const searchFilterName = store.getters.searchFilterNameFromKey(payload.key)
      const payloadValue = Array.isArray(payload.value) ? payload.value[0] : payload.value
      store.commit(types.SET_SEARCH_LIST_FILTER, {filterName: searchFilterName, query: {value: payloadValue}})

      store.dispatch('searchApiCall')
      return
    }
    payload.filter = _.find(state, ['key', payload.key])

    store.commit(types.SET_FILTER, payload)

    if (payload.key === 'g') {
      const selectedGenderRow = payload.filter.list.find(row => row.value === payload.value)
      store.commit(types.SEASON_LESS, selectedGenderRow.seasonLess)
    }

    if (payload.filter.reset_filters) {
      let filterToReset = ['colors', 'sizes', 'type', 'fit', 'reversible']
      store.commit(types.RESET_FILTERS, filterToReset)
      store.dispatch('getFilters')
    }

    if (payload.filter.update_route) {
      store.dispatch('prepareRoute')
    }

    payload = null
    store.dispatch('getProducts')
  },
  setBaseFilters: (store, payload) => {
    const newPayload = {}
    const payloadKeys = Object.keys(payload)
    let seasonLess = false

    payloadKeys.forEach(filterKey => {
      const filterListRow = state[filterKey].list.find(value => value.key === payload[filterKey])
      newPayload[filterKey] = filterListRow.value

      if (filterKey === 'gender') {
        seasonLess = filterListRow.seasonLess
      }
    })

    const routeGetParam = store.rootState.route.query
    const dynamicFilterValue = []

    if (routeGetParam) {
      Object.keys(state).forEach(filterName => {
        const filter = state[filterName]
        if (routeGetParam[filter.key]) {
          store.commit(types.SET_FILTER, {
            filter: filter,
            key: filter.key,
            value: filter.key === 'c' ? routeGetParam[filter.key].split('|') : routeGetParam[filter.key]
          })
          dynamicFilterValue.push(routeGetParam[filter.key])
        }
      })
    }

    if (newPayload.season) {
      dynamicFilterValue.push(newPayload.season)
    }

    if (dynamicFilterValue.length > 0) {
      store.commit(types.SET_DYNAMIC_FILTERS, dynamicFilterValue)
    }

    store.commit(types.SET_BASE_FILTERS, newPayload)
    store.commit(types.SEASON_LESS, seasonLess)

    store.dispatch('getProducts')
    store.dispatch('prepareRoute')
  },
  getFilters: (store) => {
    let genderId = _.intersection(state.gender.selected.split('|'), state.season.selected.split('|'))[0]

    if (state.season.selected === '') {
      genderId = state.gender.selected
    }

    return api.fetchFilters(genderId, (filters) => {
      store.commit(types.RECEIVE_FILTERS, filters)
      store.commit(types.SET_CUSTOM_FILTERS, {filters: filters, currentGender: store.getters.currentGender})
    })
  },
  resetFilters: (store) => {
    let filterToReset = ['colors', 'sizes', 'type', 'fit', 'reversible']
    store.commit(types.RESET_FILTERS, filterToReset)
    store.dispatch('getProducts')
  },
  prepareRoute: (store) => {
    const segmentGender = state.gender.list.find(row => row.value === state.gender.selected).label.toLowerCase()
    const selectedSeason = state.season.list.find(row => row.value === state.season.selected)
    const segmentSeason = selectedSeason ? selectedSeason.label.toLowerCase() : ''

    store.dispatch('setRoute', {segment1: segmentGender, segment2: segmentSeason})
  },
  toggleFilterPopover: (store, payload) => {
    store.commit(types.TOGGLE_FILTER_POPOVER, payload)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filters.js